// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import statusHistoryReducer from "./features/statusHistorySlice";
import vendorSlice from "./features/vendors/vendorSlice";
import ticketTrashSlice from "./features/tickets/ticketsSlice";
import clientSlice from './features/client/clientSlice'
import categoryReducer from './features/category/category'
import dailyCateringOrder from './features/client/dailyCateringOrderSlice'
const store = configureStore({
  reducer: {
    statusHistory: statusHistoryReducer,
    vendors: vendorSlice,
    ticketTrashSlice: ticketTrashSlice,
    clientSlice:clientSlice,
    category: categoryReducer,
    dailyCateringOrder:dailyCateringOrder
  },
  devTools: true,
});

export default store;
